<script setup lang="ts">
// Label/value row in the amortization details block (ported from @old AmortizationText).
// The value cell is tabular-nums: these rows stack into a right-hand column of amounts, and
// equal-width digits keep that column aligned (same treatment as AmortizationAdvices and
// BAmountBreakdown). The label stays proportional — it is left-aligned prose.
defineProps<{
  label: string
  value: string
}>()
</script>

<template>
  <div class="d-flex justify-space-between mb-4">
    <div class="text-body-medium font-weight-medium">
      {{ label }}
    </div>
    <div class="text-body-medium tabular-nums">
      {{ value }}
    </div>
  </div>
</template>
